import { useContext } from 'react';
import { UserSecurityContext } from '../userSecurityProvider';

export const useUserPermissions = () => {
  const security = useContext(UserSecurityContext) as any;

  return {
    policies: security?.policies || [],
    isSecurityLoading: Boolean(security?.isSecurityLoading)
  };
};
